import { combineReducers } from 'redux'
import OauthConfigReducer from './OauthConfigReducer'
import SessionReducer from './SessionReducer'

export default combineReducers({
  oauthConfig: OauthConfigReducer,
  session: SessionReducer
})
